import {
    DELIVERED,
    IN_TRANSIT,
    OUT_FOR_DELIVERY,
    RECEIVED_AT_ORIGIN,
    UNLOADED,
    CONTAINERIZED,
    LOADED,
    DEPARTED,
    ARRIVED,
    BOOKING_CONFIRMED,
    SHIPPED,
    IN_TRANSIT_TO_PICKUP,
    CARRIER_RECEIVED_SHIPMENT,
    DEPARTED_TERMINAL,
} from "../shared/strings/constants";
import { ProgressLabel } from "@amzn/rttv_web_app/lib/shared/constants";

export const getProgressLabelEnum = (currentStatus : string) => {
    switch (currentStatus) {
        case (DELIVERED):
            return ProgressLabel[DELIVERED];
        case (OUT_FOR_DELIVERY):
            return ProgressLabel[OUT_FOR_DELIVERY];
        case (IN_TRANSIT):
            return ProgressLabel[IN_TRANSIT];
        case (RECEIVED_AT_ORIGIN):
            return ProgressLabel.RECEIVED_AT_ORIGIN;
        case (BOOKING_CONFIRMED):
            return ProgressLabel.BOOKING_CONFIRMED;

        // Air cargo specific statuses
        case (CONTAINERIZED):
            return ProgressLabel.CONTAINERIZED;
        case (LOADED):
            return ProgressLabel.LOADED;
        case (DEPARTED):
            return ProgressLabel.DEPARTED;
        case (ARRIVED):
            return ProgressLabel.ARRIVED;
        case (UNLOADED):
            return ProgressLabel.UNLOADED;

        // LTL specific statuses
        case (SHIPPED):
            return ProgressLabel.SHIPPED;
        case (IN_TRANSIT_TO_PICKUP):
            return ProgressLabel.IN_TRANSIT_TO_PICKUP;
        case (CARRIER_RECEIVED_SHIPMENT):
            return ProgressLabel.CARRIER_RECEIVED_SHIPMENT;
        case (DEPARTED_TERMINAL):
            return ProgressLabel.DEPARTED_TERMINAL;
            
        default:
            return ProgressLabel.ORDERED;
    }
};